import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "outer-bg"
};
const _hoisted_2 = {
  class: "main"
};
const _hoisted_3 = {
  class: "row-column"
};
const _hoisted_4 = {
  class: "row-column"
};
const _hoisted_5 = {
  class: "row-column"
};
import { onMounted, reactive, ref } from 'vue';
import { useBigScreen } from '@/hooks/useBigScreen.js';
import CampusHeader from './components/CampusHeader.vue';
import BaseCount from './components/BaseCount.vue';
import MonthHotCookbook from './components/MonthHotCookbook.vue';
import MonthHotMeal from './components/MonthHotMeal.vue';
import StarLevelCount from './components/StarLevelCount.vue';
import BannerList from './components/BannerList.vue';
import nullImg from '@/assets/images/screen/null.png';
import { unitBaseData, unitHotData, unitEvaluationData, unitTodayData } from '@/api/index.js';
import useUserInfo from '@/stores/user';
export default {
  __name: 'school-only',
  setup(__props) {
    let userInfo = useUserInfo();
    let screen = ref();
    onMounted(() => {
      useBigScreen(screen);
      getBaseData();
      getHotData();
      getEvaluationData();
      getTodayData();
    });

    // API 获取基础数据
    let baseInfo = reactive({
      unitNumber: 0,
      dailyActiveNumber: 0,
      monthlyActiveNumber: 0,
      goodsNumber: 0,
      recipeNumber: 0,
      setMealNumber: 0
    });
    function getBaseData() {
      unitBaseData().then(data => {
        for (let key in baseInfo) {
          baseInfo[key] = data[key] || 0;
        }
      });
    }
    // API 获取热门数据
    let cookbookList = ref([]);
    let mealList = ref([]);
    function getHotData() {
      unitHotData().then(data => {
        let {
          recipeList,
          setMealList
        } = data;
        let cookbook = recipeList?.map(item => {
          return {
            id: item.id,
            name: item.name,
            url: item?.coverImage?.url || nullImg
          };
        });
        cookbookList.value = cookbook.length > 3 ? cookbook.slice(0, 3) : cookbook;
        let meal = setMealList?.map(item => {
          let urlList = [];
          for (let url of item.recipeList) {
            if (url?.coverImage?.url && urlList.length < 4) {
              urlList.push(url.coverImage.url);
            }
          }
          for (let i = urlList.length; i < 4; i++) {
            urlList.push(nullImg);
          }
          return {
            id: item.id,
            name: item.name,
            urlList: urlList
          };
        });
        mealList.value = meal.length > 3 ? meal.slice(0, 3) : meal;
      });
    }
    // API 获取满意度数据
    let evaluationInfo = reactive({
      foodQualitySatisfaction: 0,
      foodHygieneSatisfaction: 0,
      serviceAttitudeSatisfaction: 0,
      diningEnvironmentSatisfaction: 0
    });
    function getEvaluationData() {
      unitEvaluationData().then(data => {
        for (let key in evaluationInfo) {
          evaluationInfo[key] = data[key] || 0;
        }
      });
    }
    // API 今日食谱
    let todayList = ref([]);
    let colorList = ['#6fe881', '#ff871f', '#f9dd47', '#1fb4ff', '#c8db50'];
    function getTodayData() {
      let arrList = [];
      unitTodayData().then(data => {
        let dataList = data || [];
        dataList.forEach(item => {
          let unitName = item?.unit?.name || '';
          let mealName = item?.mealTimes?.name || '';
          // 菜谱
          if (item?.recipeList?.length > 0) {
            let urlList = [];
            let recipeNames = item.recipeList.reduce((acc, recipe) => {
              if (recipe?.coverImage?.url && urlList.length < 3) {
                urlList.push(recipe.coverImage.url);
              }
              if (recipe.name) {
                acc = acc ? acc + '、' + recipe.name : recipe.name;
              }
              return acc;
            }, '');
            for (let i = urlList.length; i < 3; i++) {
              urlList.push(nullImg);
            }
            let nutritionList = [];
            item.recipeNutritionList.forEach((eneray, index) => {
              if (index < 5) {
                eneray['bgColor'] = colorList[index];
                eneray.proportion = keep2Decimal(eneray.proportion * 100);
                eneray.recommendedValue = eneray.recommendedValue > 100 ? 100 : eneray.recommendedValue;
                nutritionList.push(eneray);
              }
            });
            let obj = {
              name: `${unitName}：今日${mealName}(菜单)`,
              subname: recipeNames,
              urlList: urlList,
              nutritionList
            };
            arrList.push(obj);
          }
          // 套餐
          if (item?.setMealList?.length > 0) {
            item.setMealList.forEach(meal => {
              let urlList = [];
              let recipeNames = meal.recipeList.reduce((acc, recipe) => {
                if (recipe?.coverImage?.url && urlList.length < 3) {
                  urlList.push(recipe.coverImage.url);
                }
                if (recipe.name) {
                  acc = acc ? acc + '、' + recipe.name : recipe.name;
                }
                return acc;
              }, '');
              for (let i = urlList.length; i < 3; i++) {
                urlList.push(nullImg);
              }
              let nutritionList = [];
              meal.recipeNutritionList.forEach((eneray, index) => {
                if (index < 5) {
                  eneray['bgColor'] = colorList[index];
                  eneray.proportion = keep2Decimal(eneray.proportion * 100);
                  eneray.recommendedValue = eneray.recommendedValue > 100 ? 100 : eneray.recommendedValue;
                  nutritionList.push(eneray);
                }
              });
              let obj = {
                name: `${unitName}：今日${mealName}(${meal.name})`,
                subname: recipeNames,
                urlList: urlList,
                nutritionList
              };
              arrList.push(obj);
            });
          }
        });

        // 格式成二维数组
        todayList.value = [];
        for (let i = 0; i < arrList.length; i += 3) {
          todayList.value.push(arrList.slice(i, i + 3));
        }
      });
    }
    function keep2Decimal(num) {
      if (isNaN(num)) return NaN;
      return Number.isInteger(+num) ? +num : Number((+num).toFixed(2));
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "page",
        ref_key: "screen",
        ref: screen
      }, [_createVNode(CampusHeader, {
        subtitle: _unref(userInfo)?.loginInfo?.unitName
      }, null, 8, ["subtitle"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(BaseCount, {
        "base-info": _unref(baseInfo)
      }, null, 8, ["base-info"])]), _createElementVNode("div", _hoisted_4, [_createVNode(MonthHotCookbook, {
        "cookbook-list": _unref(cookbookList)
      }, null, 8, ["cookbook-list"]), _createVNode(MonthHotMeal, {
        "meal-list": _unref(mealList)
      }, null, 8, ["meal-list"]), _createVNode(StarLevelCount, {
        "evaluation-info": _unref(evaluationInfo)
      }, null, 8, ["evaluation-info"])]), _createElementVNode("div", _hoisted_5, [_createVNode(BannerList, {
        "today-list": _unref(todayList)
      }, null, 8, ["today-list"])])])], 512)]);
    };
  }
};